import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { useState } from 'react';
import { useGetUsersByIdsQuery } from '../../__generated__/chirp/com/hubspot/appusers/rpc/UsersRpc.hooks';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
import { navigateTo } from 'marketplace-ui-common/utils/DetailsPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function TemplateUsageInfo({
  usages
}) {
  const {
    isEmbedded,
    name
  } = useDetailsPageContext();
  const [modalOpen, setModalOpen] = useState(false);
  const {
    data: users
  } = useGetUsersByIdsQuery({
    variables: {
      userIds: [...usages.map(usage => usage.createdBy)]
    },
    skip: usages.length === 0
  });
  function toggleModal() {
    setModalOpen(!modalOpen);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `detailsPage.productDetailsCard.usages.label.${usages.length > 1 ? 'plural_jsx' : 'singular_jsx'}`,
      elements: {
        Button
      },
      options: {
        count: usages.length,
        use: 'link',
        onClick: toggleModal
      }
    }), modalOpen && /*#__PURE__*/_jsxs(Modal, {
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.productDetailsCard.usages.popover.header"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: () => setModalOpen(false)
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        maxBlockSize: "70vh",
        children: usages.map((usage, index) => {
          const createdByUser = users === null || users === void 0 ? void 0 : users.users.find(user => user.id === usage.createdBy);
          return /*#__PURE__*/_jsxs(View, {
            flexDirection: "column",
            paddingBlock: "200",
            children: [/*#__PURE__*/_jsx(Button, {
              use: "link",
              onClick: () => navigateTo(usage.href, isEmbedded),
              external: isEmbedded,
              children: /*#__PURE__*/_jsx(Text, {
                typography: "body-125",
                children: usage.workflowName || name
              })
            }), /*#__PURE__*/_jsx(Flex, {
              alignItems: "center",
              children: /*#__PURE__*/_jsx(Text, {
                as: "span",
                typography: "body-100",
                children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                  message: "detailsPage.productDetailsCard.usages.popover.created_jsx",
                  elements: {
                    Duration: FormattedDuration
                  },
                  options: {
                    createdBy: createdByUser ? `${createdByUser.firstName} ${createdByUser.lastName}` : undefined,
                    from: usage.createdAt,
                    to: new Date()
                  }
                })
              })
            })]
          }, `usage-${name}-${usage.createdAt}-${index}`);
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: () => setModalOpen(false),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `detailsPage.productDetailsCard.usages.popover.close`
          })
        })
      })]
    })]
  });
}